import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ApiRouteConfig} from "../../../../config/api.route.config";
import {Observable} from "rxjs";
import {ActionsQuery} from "./actions-query";
import {
  ChappListLoadResponse,
} from "@npm.chapps.com/chapps.common.angular.library/lib/components/chapps-list/interfaces/any-chapps-list-load-response";
import {InterventionTeamSummary} from "../../../buildings/model/Intervention-team-summary";
import {Action} from '../../../common/model/action';
import {InterventionTeamDetailDto} from '../../intervention-teams/teams/intervention-team-detail.dto';

@Injectable()
export class ActionsResource {

  constructor(
    private httpClient: HttpClient,
    private config: ApiRouteConfig,
  ) {
  }

  public all(query?: ActionsQuery): Observable<ChappListLoadResponse<Action>> {
    const params = query
      ?.params()
      .append('pageNumber', 1)
      .append('pageSize', 1000);
    return this.httpClient.get<ChappListLoadResponse<Action>>(this.config.MAINTENANCE_ACTIONS, {params})
  }

  public assign(jobId: string, teamId: string) {
    const endpoint = this.config.getRouteWithInjectedParams(this.config.JOBS_ASSIGN, [jobId, teamId]);
    return this.httpClient.put(endpoint, {});
  }

  public delete(action: Action) {
    const endpoint = this.config.getRouteWithInjectedParams(
      this.config.DELETE_MAINTENANCE_ACTION, [action.id]
    );
    return this.httpClient.delete(endpoint);
  }

  public sendAssignedActionsOf(team: InterventionTeamDetailDto | InterventionTeamSummary) {
    const endpoint = this.config.getRouteWithInjectedParams(
      this.config.SEND_MAINTENANCE_ACTIONS, [team.id],
    );
    return this.httpClient.get(endpoint);
  }

  unassign(action: Action) {
    const endpoint = this.config.getRouteWithInjectedParams(
      this.config.JOBS_UNASSIGN, [action.id]
    );
    return this.httpClient.put(endpoint, {});
  }


  public sendNotification(id: string) {
    const endpoint = this.config.getRouteWithInjectedParams(
      this.config.JOBS_SEND, [id]
    );
    return this.httpClient.post(endpoint, null);
  }
}
